import { PandaIcon } from './PandaIcon';

/**
 * author: Austin Andrews
 * id A797FE46-DF68-4179-85BE-172BD79F0667
 * name panda
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/panda.svg
 * tags
 * - Animal 
 */
export const EmoticonPandaIcon = PandaIcon;
export default EmoticonPandaIcon